@if (showUpdateMessage()) {
  <div
    class="update-message fixed bottom-10 left-[4.5rem] z-10 rounded-lg border border-primary-25 bg-white p-4 shadow-md drop-shadow-lg"
  >
    <p>A new version of the website is available</p>

    <div class="mt-4 flex justify-end">
      <button
        type="button"
        class="mr-4 cursor-pointer"
        (click)="cancelUpdate()"
      >
        Cancel
      </button>

      <button
        type="button"
        class="font-bold text-primary cursor-pointer"
        (click)="confirmUpdate()"
      >
        Update Now
      </button>
    </div>
  </div>
}